import { PROPERTY_SUBMODULES } from 'api/helpers/permissions';

export const ROUTE_PERMISSION_MAP = {
  '/admin-management': 'admins',
  '/investor-management': 'investors',
  '/issuer-management': 'investors',
  '/issuer-management/:issuerId': 'investors',
  '/investors': 'investors',
  '/early-investors': 'investors',
  '/agent-verification': 'agents',
  '/agent-details/:id': 'agents',
  '/property-managers': 'property_managers',
  '/view-user/:id': 'users_any',
  '/investore/:id': 'investors',
  '/draft-properties': 'properties_approval_requests',
  '/approved-properties': 'properties_approved',
  '/subscribed-properties': 'properties_subscribed',
  '/purchased-properties': 'properties_purchased',
  '/rejected-properties': 'properties_rejected',
  '/property-review/:id': 'properties_any',
  '/edit-property/:propertyId': 'properties_any',
  '/published-properties': 'properties_any',
  '/issuer': 'issuer',
  '/market-management': 'market_management',
  '/market-detail': 'market_management',
  '/property-financials': 'property_financials',
  '/comparable-property': 'comparable_property',
  '/comparable-property/:propertyId/:action': 'comparable_property',
  '/cashflow': 'cashflow',
  '/rental-detail': 'cashflow',
  '/transactions-management': 'transactions',
  '/portfolio': 'portfolio',
  '/portfolio-property/:id': 'portfolio',
  '/property-proposals/:id': 'portfolio',
  '/view-proposal/:id': 'portfolio',
  '/investor-relations': 'investor_relations',
  '/investor-relations/:referralId': 'investor_relations',
  '/referrals-transactions/:refreeId/:referralId': 'investor_relations',
  '/management-master/fee-master': 'fee_master',
  '/management-master/payment-configuration': 'payment_configuration',
  '/management-master/notification-settings': 'notification_settings',
};

const propertySubmodules = new Set(PROPERTY_SUBMODULES || []);

export const getPermissionKeyForPath = path => {
  if (!path) return null;
  return ROUTE_PERMISSION_MAP[path] || null;
};

export const isSuperAdminUser = userData => {
  if (userData && typeof userData.isSuperAdmin === 'boolean') {
    return userData.isSuperAdmin;
  }
  const stored = localStorage.getItem('isSuperAdmin');
  return stored === 'true' || stored === true;
};

const hasAnyPropertyPermission = (permissions, action = 'view') => {
  if (permissions?.properties?.[action]) return true;
  return (PROPERTY_SUBMODULES || []).some(key => permissions?.[key]?.[action]);
};

const hasAnyUserPermission = (permissions, action = 'view') => {
  return (
    permissions?.investors?.[action] ||
    permissions?.property_managers?.[action]
  );
};

export const hasPermission = (permissions, key, action = 'view', isSuperAdmin = false) => {
  if (isSuperAdmin) return true;
  if (!key) return true;
  const perms = permissions || {};

  if (key === 'properties_any') {
    return hasAnyPropertyPermission(perms, action);
  }
  if (key === 'users_any') {
    return hasAnyUserPermission(perms, action);
  }

  if (propertySubmodules.has(key) && perms?.properties?.[action]) {
    return true;
  }

  return perms?.[key]?.[action] === true;
};
